var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import Typography from '../Typography';
import { CheckboxWrapper, CheckboxInput, Checkmark, CheckboxLabel, DisabledCheckmark, } from './styled';
import { DisabledCheckIcon, EnabledCheckIcon } from './Icons';
const Checkbox = (_a) => {
    var props = __rest(_a, []);
    const { label = '', checked, onChange, disabled, id, name, value, highlightedText, size = 24, fontSize = 14, rounded = '6px', style, labelContainerStyle, } = props;
    const [internalChecked, setInternalChecked] = useState(checked);
    useEffect(() => {
        setInternalChecked(checked);
    }, [checked]);
    const handleClick = () => {
        if (!disabled) {
            const newChecked = !internalChecked;
            setInternalChecked(newChecked);
            onChange(newChecked);
        }
    };
    return (_jsxs(CheckboxWrapper, Object.assign({ style: style, onClick: handleClick }, { children: [_jsx(CheckboxInput, { id: id, type: "checkbox", "data-testid": "checkbox", checked: internalChecked, onChange: () => { }, disabled: disabled, name: name, value: value }), internalChecked ? (_jsxs(Checkmark, Object.assign({ isChecked: internalChecked, size: size, rounded: rounded }, { children: [' ', _jsx(EnabledCheckIcon, { size: size, rounded: rounded })] }))) : (_jsx(Checkmark, { isChecked: internalChecked, size: size, rounded: rounded })), label !== '' && (_jsx(CheckboxLabel, Object.assign({ htmlFor: id, isChecked: internalChecked, highlightedText: highlightedText, fontSize: fontSize, style: labelContainerStyle }, { children: disabled ? (_jsxs(_Fragment, { children: [_jsx(DisabledCheckmark, { children: _jsx(DisabledCheckIcon, { size: size, rounded: rounded }) }), _jsx(Typography, Object.assign({ color: "#8E90A4", fontSize: fontSize }, { children: label }))] })) : (_jsx(Typography, Object.assign({ color: internalChecked && highlightedText ? 'var(--Azul-primario-500, #0057B8)' : '#5B5D71', fontSize: fontSize }, { children: label }))) })))] })));
};
export default Checkbox;
//# sourceMappingURL=index.js.map